import { Component, ElementRef, HostListener, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AutoDiscountModel } from '../model/autodiscount.model';
import { AutoDiscountService } from '../auto-discount.service';
import { SnackBarData } from 'src/app/common/components/snackbar/model/snackbar.model';
import { SnackBarService } from 'src/app/common/components/snackbar/snackbar.service';
import { FormBuilder, FormGroup, NgModel, Validators } from '@angular/forms';
import { ConfirmDialogComponent, ConfirmDialogModel } from 'src/app/common/components/confirm-dialog/confirm-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { DirtyCheck } from 'src/app/common/guards/form-deactivate.guard';
import { ItemCategoryService } from '../../../products/item-category/item-category.service';
import { ProductDialogComponent } from '../dialogs/product-dialog/product-dialog.component';
import { ProductItemDialogComponent } from '../dialogs/product-item-dialog/product-item-dialog.component';
import { SaleItemService } from '../../../products/sale-item/sale-item.service';
import { PermissionService } from 'src/app/auth/permission.service';
@Component({
  selector: 'app-auto-discount-edit',
  standalone: false,
  templateUrl: './auto-discount-edit.component.html',
  styleUrl: './auto-discount-edit.component.scss'
})
export class AutoDiscountEditComponent {
  title: string = "Auto Discount Details";
  editForm: FormGroup;
  isFormDirty: boolean = false;
  selectedValue = 1;
  ratingList: AutoDiscountModel[] = [];
  isExpandedSaleItems = false;
  resetButtonEnabledForSaleItems: boolean = false;
  saleItemListData: any[] = [];
  productList: any[] = [];
  filteredCategoryList: any;
  itemCategoryList: any[] = [];
  selectedItems: any[] = [];
  selectedSaleitemIds: any[] = [];
  saleItemSelectionInvalid = false;
  alreadyDiscountedItemsInvalid = false;
  usedSaleItems: any = {};
  mainGroupList: any[] = [];
  subGroupList: any[] = [];
  saleItemList: any[] = [];
  selectedSuperClassId: string = '';
  selectedSubClassId: string = '';
  isSuperClassInvalid: boolean = false;
  isSubClassInvalid: boolean = false;
  filteredSubGroups: any[] = [];
  filteredSaleItems: any[] = [];
  offerItemListEmpty = false;
  varianceErrors?: { [key: number]: boolean };
  @ViewChild('qtyInputRef') qtyInputRef!: ElementRef;
  @ViewChild('saleQty') saleQty!: NgModel;

  autoDiscountInfo: AutoDiscountModel = {

    code: "",
    name: "",
    description: "",
    is_valid: 1,
    purchase_offer_based_on: 2,
    offer_based_on: 2,
    buy: {
      based_on: 'sale_item',
      trigger_on: []
    },
    offer: {
      type: 'sale_item',
      offer: []
    },
    super_cls_id: undefined,
    sub_cls_id: undefined,
    saleitem_qty: undefined,
  };
  sys_repl_ts: string | null = null;
  permission: any;





  constructor(private router: Router,
    private builder: FormBuilder,
    private route: ActivatedRoute,
    private autoDiscountService: AutoDiscountService,
    private snackBarService: SnackBarService,
    public dialog: MatDialog,
    private permissionService: PermissionService,
    private itemCategoryService: ItemCategoryService,
    private saleItemService: SaleItemService) {


    let discountId = this.route.snapshot.paramMap.get('id');
    this.editForm = this.builder.group({
      code: this.builder.control(this.autoDiscountInfo.code, [Validators.required, Validators.maxLength(10)]),
      name: this.builder.control(this.autoDiscountInfo.name, [Validators.required, Validators.maxLength(50)]),
      description: this.builder.control(this.autoDiscountInfo.description),
      offer_based_on: [{ value: '2', disabled: true }],
      saleitem_selected_offer: [{ value: '2', disabled: true }],
      //is_valid: this.builder.control(this.autoDiscountInfo.is_valid, []),


    });

    this.editForm.valueChanges.subscribe(() => {
      this.isFormDirty = true;
    });

    if (discountId !== null && parseInt(discountId) !== 0) {
      this.setautoDiscountInfo(discountId);
    }
    this.permission = this.permissionService.getRowPermission(this.permissionService.getPagePermission('discount'), discountId);

  }
  ngOnInit(): void {
    let discountId = this.route.snapshot.paramMap.get('id');
    if (discountId === null || parseInt(discountId) === 0) {
      this.loadData();
    }
    this.loadCategoryList();
    this.loadProducts();
  }
  toBoolean(value: string | number | null | undefined): number {
    return value === '1' || value === 1 ? 1 : 0;
  }


  /**
   * Dirtyness check
   * @returns 
   */
  isDirty(): boolean {
    return this.isFormDirty;
  }

  /**
   * checks the form is edited
   */
  navBack(): void {

    this.router.navigate(['/promotion/auto-discount']);

  }


  // getCatIdByItemId(itemId: string | number): string | undefined {
  //   const item = this.saleItemList.find(i => +i.id === +itemId);
  //   return item?.cat_id;
  // }
  // getSuperClsIdByItemId(itemId: string | number): string | undefined {
  //   const item = this.saleItemList.find(i => +i.id === +itemId);
  //   return item?.superClsId;
  // }
  setautoDiscountInfo(discountId: any): void {
    this.autoDiscountService.getMasterData().subscribe({
      next: (baseResponse: any) => {
        // ✅ Master data is ready
        this.mainGroupList = baseResponse.data.mainGroup;
        this.subGroupList = baseResponse.data.subGroup;
        this.saleItemList = baseResponse.data.saleItems;
        this.usedSaleItems = baseResponse.data.usedSaleItems || {};

        // Now get the discount data
        this.autoDiscountService.getAutoDiscountById(discountId).subscribe({
          next: (response) => {
            if (response.status === 'SUCCESS') {
              this.buildDiscountFromResponse(response); // ✅ Safe to call here
              this.sys_repl_ts = response.data.sys_repl_ts;
              this.editForm.patchValue(this.autoDiscountInfo);
              this.title = this.getTitle();
              this.isFormDirty = false;
            } else {
              this.snackBarService.openSnackBar({
                message: response.message,
                title: 'Failed!!!',
                type: 'error'
              });
            }
          },
          error: () => {
            this.snackBarService.openSnackBar({
              message: 'Failed to get discount data from server.',
              title: 'Error',
              type: 'error'
            });
          }
        });
      },
      error: () => {
        this.snackBarService.openSnackBar({
          message: 'Failed to load master data.',
          title: 'Error',
          type: 'error'
        });
      }
    });
  }


  /**
   * Set the variable from response
   * @param response
   */
  buildDiscountFromResponse(response: any): void {
    let discountInfo = response.data.autoDiscount;
    this.autoDiscountInfo.id = discountInfo.id;
    this.autoDiscountInfo.code = discountInfo.code;
    this.autoDiscountInfo.name = discountInfo.name;
    this.autoDiscountInfo.description = discountInfo.description;
    // console.log(this.autoDiscountInfo.is_valid);
    this.autoDiscountInfo.is_valid = +discountInfo.is_valid;
    this.autoDiscountInfo.purchase_offer_based_on = 2;;
    this.autoDiscountInfo.offer_based_on = 2;

    let parsedOffer: any = {};
    let parsedBuy: any = {};
    parsedBuy = typeof discountInfo.buy === 'string'
      ? JSON.parse(discountInfo.buy)
      : discountInfo.buy;
    if (parsedBuy && Array.isArray(parsedBuy.trigger_on)) {
      this.autoDiscountInfo.buy = {
        based_on: parsedBuy.based_on,
        trigger_on: parsedBuy.trigger_on.map((item: any) => ({
          id: +item.id,
          qty: +item.qty
        }))
      };
    }


    const triggerIds = parsedBuy.trigger_on.map((item: any) => +item.id);
    const triggerQtys = parsedBuy.trigger_on.map((item: any) => +item.qty);
    this.selectedSaleitemIds = triggerIds;
    const selectedItem = this.saleItemList.find(item => +item.id === triggerIds[0]);
    this.autoDiscountInfo.saleitem_qty = triggerQtys[0];
    if (triggerIds.length > 0) {
      this.isExpandedSaleItems = true;
      this.resetButtonEnabledForSaleItems = true;
    }

    const subClsId = selectedItem?.cat_id;
    const superClsId = selectedItem?.superClsId;
    this.autoDiscountInfo.sub_cls_id = subClsId;
    this.autoDiscountInfo.super_cls_id = superClsId;


    this.selectedSuperClassId = superClsId;
    this.filteredSubGroups = this.subGroupList.filter(sg => sg.superClsId === superClsId);
    this.selectedSubClassId = subClsId;
    this.filteredSaleItems = this.saleItemList.filter(item =>
      item.superClsId === superClsId && item.cat_id === subClsId
    );

    this.saleItemListData = [];
    var index = 0;
    this.filteredSaleItems.forEach((item: any) => {
      var data = { index: index, item: item, selected: false };
      this.saleItemListData.push(data);
      index++;
    });




    parsedOffer = typeof discountInfo.offer === 'string'
      ? JSON.parse(discountInfo.offer)
      : discountInfo.offer;
    if (Array.isArray(parsedOffer.offer)) {
      this.autoDiscountInfo.offer = {
        type: parsedOffer.type,
        offer: parsedOffer.offer.map((item: any) => ({
          id: +item.id,
          qty: +item.qty,
          is_percentage: +item.is_percentage,
          variance: +item.variance
        }))
      };
    }

    this.saleItemListData = [];
    var index = 0;

    this.filteredSaleItems.forEach((item: any) => {
      const isSelected = triggerIds.includes(+item.id); // Check if item is selected
      this.saleItemListData.push({
        index: index,
        item: item,
        selected: isSelected
      });
      index++;
    });

    // Also inject any globally selected items from other categories so the right pane shows them
    this.saleItemList.forEach((item: any) => {
      const isSelected = triggerIds.includes(+item.id);
      if (isSelected) {
        const found = this.saleItemListData.find(d => +d.item.id === +item.id);
        if (!found) {
          this.saleItemListData.push({
            index: index,
            item: item,
            selected: true
          });
          index++;
        }
      }
    });

  }



  /**
   * 
   * @returns  the title for the dialog
   * sine the same dialog is used for edit and new, dynamically decide the title
   */
  getTitle(): string {
    let title = (this.autoDiscountInfo.id == 0) ? "Auto Discount Details" : "Editing : " + this.autoDiscountInfo.name;
    return title;
  }

  /**
 * Validates whether at least one sale item has been selected.
 * 
 * - Checks if any item in the sale item list is marked as `selected`.
 * - If none are selected, sets `saleItemSelectionInvalid` to true (used for UI validation).
 * 
 * @returns `true` if at least one item is selected, otherwise `false`.
 */
  validateSaleItemSelection(): boolean {
    const isValid = this.selectedSaleitemIds.length > 0;
    this.saleItemSelectionInvalid = !isValid;
    return isValid;
  }

  /**
   * Validates if the newly selected sale items have already been assigned to another discount
   */
  validateAlreadyDiscounted(): boolean {
    const selectedIds = this.selectedSaleitemIds;
    let hasUsed = false;
    for (let id of selectedIds) {
      // Check if it's assigned to another discount (i.e. used in DB, but not equal to the current editing discount ID)
      if (this.usedSaleItems[id]) {
        const ownerId = this.usedSaleItems[id];
        if (ownerId !== this.autoDiscountInfo.id) {
          hasUsed = true;
          break;
        }
      }
    }
    this.alreadyDiscountedItemsInvalid = hasUsed;
    return !hasUsed;
  }

  /**
 * Validates that both Super Class and Sub Class are selected.
 * 
 * - Sets `isSuperClassInvalid` to true if `selectedSuperClassId` is not selected.
 * - Sets `isSubClassInvalid` to true if `selectedSubClassId` is not selected.
 * 
 * These flags can be used to show validation errors in the UI.
 * 
 * @returns `true` if both selections are valid, otherwise `false`.
 */

  validateSelection(): boolean {
    this.isSuperClassInvalid = !this.selectedSuperClassId;
    this.isSubClassInvalid = !this.selectedSubClassId;

    return !this.isSuperClassInvalid && !this.isSubClassInvalid;
  }

  /**
     * On save
     * if the details are valid call the api to update the changes.
     */
  save(): void {
    const isSuperClsValid = !!this.selectedSuperClassId;
    const isSubClsValid = !!this.selectedSubClassId;
    const isSaleItemValid = this.validateSaleItemSelection();
    const isDiscountFree = this.validateAlreadyDiscounted();
    const isQtyValid = !!this.autoDiscountInfo.saleitem_qty;
    let isValid = true;
    this.varianceErrors = {}; // reset
    if (!this.editForm.valid) {
      this.editForm.markAllAsTouched(); // Trigger validation messages
      return;
    }


    // Step 1: Super class validation
    if (!isSuperClsValid) {
      this.isSuperClassInvalid = true;
      return;
    }

    // ✅ Step 2: Sub class validation — your line goes HERE
    if (!isSubClsValid) {
      this.isSubClassInvalid = true;
      return;
    }

    // Step 3: Sale item list validation
    if (!isSaleItemValid) {
      this.saleItemSelectionInvalid = true;
      return;
    }

    if (!isDiscountFree) {
      return;
    }

    // Step 4: Quantity validation
    if (this.saleQty.invalid) {
      this.saleQty.control.markAsTouched();

      // Scroll and focus
      setTimeout(() => {
        this.qtyInputRef?.nativeElement?.scrollIntoView({ behavior: 'smooth', block: 'center' });
        this.qtyInputRef?.nativeElement?.focus();
      }, 0);

      return; // prevent save
    }

    // Step 1: Check if offer list exists
    const offerList = this.autoDiscountInfo.offer.offer;

    if (!offerList || offerList.length === 0) {
      this.offerItemListEmpty = true;
      return;
    }

    this.offerItemListEmpty = false;
    // Step 2: Reset error map and validate all items
    this.varianceErrors = {};

    for (let offer of offerList) {
      const variance = offer.variance;
      const isEmpty = variance === null || variance === undefined;

      if (isEmpty || (offer.is_percentage && (variance < 0.1 || variance > 100)) || (!offer.is_percentage && variance < 0.1)) {
        this.varianceErrors[offer.id] = true;
        isValid = false;
      }
    }

    // Step 3: Block save if any errors
    if (!isValid) {
      return;
    }






    this.autoDiscountInfo.code = this.editForm.get("code")?.value;
    this.autoDiscountInfo.name = this.editForm.get("name")?.value;
    this.autoDiscountInfo.description = this.editForm.get("description")?.value;
    const qty = this.autoDiscountInfo.saleitem_qty;
    this.autoDiscountInfo.super_cls_id = +this.selectedSuperClassId;
    this.autoDiscountInfo.sub_cls_id = +this.selectedSubClassId;
    const selectedIds: string[] = this.selectedSaleitemIds;
    const trigger_on = selectedIds.map(id => ({
      id: +id,  // Convert string to number using +
      qty: qty ?? 1
    }));
    this.autoDiscountInfo.buy = {
      based_on: 'sale_item',
      trigger_on: trigger_on
    };




    if (this.editForm.valid) {
      this.editForm.markAllAsTouched();
      const savePayload: any = { ...this.autoDiscountInfo };
      savePayload.sys_repl_ts = this.sys_repl_ts;

      this.autoDiscountService.update(savePayload).subscribe({
        next: (response) => {
          if (response.status == 'SUCCESS') {
            // handle success
            this.isFormDirty = false;
            let snckBarData: SnackBarData = {
              type: 'success',
              title: 'Saved',
              message: 'The record for ' + this.autoDiscountInfo.name + " has been updated succesfully."
            }
            this.snackBarService.openSnackBar(snckBarData);
            this.router.navigate(['/promotion/auto-discount']);
          } else if (response.code === 'DATA_CHANGED_AT_SERVER') {
            let snackBarData: SnackBarData = {
              message: 'This record has been updated by another user. Please reload the data to see the latest changes.',
              title: 'Conflict Detected',
              type: 'error'
            }
            this.snackBarService.openSnackBar(snackBarData);
            let discountId = this.route.snapshot.paramMap.get('id');
            if (discountId) {
              this.setautoDiscountInfo(discountId);
            }
          } else {
            let snackBarData: SnackBarData = {
              message: response.message,
              title: 'Failed!!!',
              type: 'error'
            }
            this.snackBarService.openSnackBar(snackBarData);
          }
        },
        error: (error) => {
          // handle error
          let snackBarData: SnackBarData = {
            message: 'Failed to update. Connection to the server failed',
            title: 'Failed!!!',
            type: 'error'
          }
          this.snackBarService.openSnackBar(snackBarData);
        }
      });

    } else {
      this.editForm.markAllAsTouched();
    }
  }
  /**
    * populate sale items in product/category-dialog
    */
  loadProducts(): void {
    let requestData = {
      search: {
        filters: {
          column: [],
          scope: { limit: 0, offset: 0 },
        },
        sort: [{ column: "sale_item.name", order: "asc" }],
      },
    };

    this.saleItemService.getList(requestData).subscribe({
      next: (response) => {
        if (response.status === "SUCCESS") {
          this.productList = response.data.items;
        } else {
          let snackBarData: SnackBarData = {
            message: response.message,
            title: "Failed!!!",
            type: "error",
          };
          this.snackBarService.openSnackBar(snackBarData);
        }
      },
      error: (error) => {
        let snackBarData: SnackBarData = {
          message: "Failed to load products.",
          title: "Failed!!!",
          type: "error",
        };
        this.snackBarService.openSnackBar(snackBarData);
      },
    });
  }

  /**
   * Loads the items categories
   */
  loadCategoryList(): void {
    let requestData = {
      search: {
        filters: {
          column: [],
          scope: { limit: 10000, offset: 0 },
        },
        sort: [{ column: "item_classes.name", order: "asc" }],
      },
    };

    this.itemCategoryService.getList(requestData).subscribe(
      (response: {
        status: string;
        data: {
          categories: any;

        };
        message: any;
      }) => {
        if (response.status === "SUCCESS") {
          this.itemCategoryList = response.data.categories;
        } else {
          let snackBarData: SnackBarData = {
            message: response.message,
            title: "Failed!!!",
            type: "error",
          };
          this.snackBarService.openSnackBar(snackBarData);
        }
      }
    );
  }

  /**
   * populate main-grp and sub-grp and saleitems list
   */

  loadData(): void {
    this.autoDiscountService.getMasterData().subscribe(
      (response: any) => {
        this.mainGroupList = response.data.mainGroup;
        this.subGroupList = response.data.subGroup;
        this.saleItemList = response.data.saleItems;
        this.usedSaleItems = response.data.usedSaleItems || {};

        if (this.mainGroupList.length > 0) {
          this.onSuperClassChange(this.mainGroupList[0].id);
        }
      },
      (error: any) => {
      },
    );
  }

  /**
   * filter the sale items and sub-class under super clsId
   */
  onSuperClassChange(superClsId: string) {
    this.selectedSuperClassId = superClsId;
    this.autoDiscountInfo.super_cls_id = +superClsId;
    // Filter sub groups that belong to the selected super class
    this.filteredSubGroups = this.subGroupList.filter(sg => sg.superClsId === superClsId);
    if (this.filteredSubGroups.length > 0) {
      this.selectedSubClassId = this.filteredSubGroups[0].id;
      this.onSubClassChange(this.selectedSubClassId);
    } else {
      this.selectedSubClassId = '';
      this.filteredSaleItems = [];
      this.saleItemListData = [];
    }


    this.isSubClassInvalid = false; // reset error
    this.isFormDirty = true;

  }


  /**
    * filter the sale items  under sub-cls
    */

  onSubClassChange(subClsId: string) {
    this.selectedSubClassId = subClsId;
    this.autoDiscountInfo.sub_cls_id = +subClsId;
    // Filter sale items by selected super and sub class
    this.filteredSaleItems = this.saleItemList.filter(item =>
      item.superClsId === this.selectedSuperClassId &&
      item.cat_id === subClsId
    );
    this.saleItemListData = [];


    var index = 0;

    this.filteredSaleItems.forEach((item: any) => {
      const isSelected = this.selectedSaleitemIds.includes(+item.id);
      var data = { index: index, item: item, selected: isSelected };
      this.saleItemListData.push(data);
      index++;
    });

    // Also inject any globally selected items from other categories so the right pane shows them
    this.saleItemList.forEach((item: any) => {
      const isSelected = this.selectedSaleitemIds.includes(+item.id);
      if (isSelected) {
        const found = this.saleItemListData.find(d => +d.item.id === +item.id);
        if (!found) {
          this.saleItemListData.push({
            index: index,
            item: item,
            selected: true
          });
          index++;
        }
      }
    });

    this.isFormDirty = true;
  }



  /**
     * expand dropbox
     */
  toggleContent(divData: string): void {
    if (divData == "saleitems") {
      this.isExpandedSaleItems = !this.isExpandedSaleItems;
    }

  }
  /**
   * reset dropbox
   */
  reset(sourceList: any[]): any {
    sourceList.forEach(el => {
      el.selected = false;
      const index = this.selectedSaleitemIds.indexOf(+el.item.id);
      if (index > -1) {
        this.selectedSaleitemIds.splice(index, 1);
      }
    });
    this.saveToSessionStorage("saleitems");
    this.validateSaleItemSelection();
    this.validateAlreadyDiscounted();
  }

  saveToSessionStorage(selectionData: any): void {
    // Get selected shop IDs (if none are selected, treat it as "ALL")
    if (selectionData == "saleitems") {
      this.saleItemListData.forEach(listItem => {
        const itemId = +listItem.item.id;
        if (listItem.selected) {
          if (!this.selectedSaleitemIds.includes(itemId)) {
            this.selectedSaleitemIds.push(itemId);
          }
        } else {
          const index = this.selectedSaleitemIds.indexOf(itemId);
          if (index > -1) {
            this.selectedSaleitemIds.splice(index, 1);
          }
        }
      });



      // If no shops are selected, we treat it as "ALL" (empty array means all shops)
      if (this.selectedSaleitemIds.length > 0) {
        this.resetButtonEnabledForSaleItems = true;
      } else {
        this.resetButtonEnabledForSaleItems = false;
      }

    }
    const selectedData = {
      saleitemsIds: this.selectedSaleitemIds,
    };
    // Save to sessionStorage
    sessionStorage.setItem('selectedSaleItems', JSON.stringify(selectedData));
  }




  onListSelectionChange(selectionData: any): void {
    this.saveToSessionStorage(selectionData);
    this.validateSaleItemSelection();
    this.validateAlreadyDiscounted();
    this.isFormDirty = true;
  }
  /**
   * show count in selected items from a dropbox
   */
  getSelectedCount(sourceList: any[]): string {
    const total = sourceList.length;
    const selected = this.selectedSaleitemIds.length;
    return `${total}/${selected > 0 ? selected : 'ALL'}`;
  }

  onlyNumberKey(event: KeyboardEvent) {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      event.preventDefault();
    }
  }

  /**
    * show dialog box for product/category based filtering
    */
  openSelectionTypeDialog(): void {
    const dialogRef = this.dialog.open(ProductDialogComponent, {
      width: "400px",
    });

    dialogRef.afterClosed().subscribe((result: any) => {
      if (result) {
        this.openProductBrowseDialog(result.type);
      }
    });
  }
  /**
   * Filter the item category list based on items
   * @returns 
   */
  getFilteredCategoryList(): any[] {
    if (this.filteredCategoryList == undefined || this.filteredCategoryList.length == 0) {
      this.filteredCategoryList = this.itemCategoryList.filter((ic: any) =>
        this.productList.some((si: any) => si.sub_class_id == ic.id)
      );

    }
    return this.filteredCategoryList;
  }
  /**
    * show dialog box for product/category based filtering
    */
  getSelectedItemList(): any {
    var selectedItemList: number[] = [];
    return this.productList.filter((product: { id: number, item_type: number }) =>
      selectedItemList.includes(product.id)
    );
  }
  /**
    * show dialog box for product/category based filtering
    */
  openProductBrowseDialog(browseBy: any): void {

    let browseItems = [];
    if (browseBy == "product") {
      browseItems = this.productList;
    } else {
      browseItems = this.getFilteredCategoryList();
    }

    // Assuming you have information about items to pre-select, update selectedItems accordingly
    // For example, if you have a variable preSelectedItems with the IDs of items to pre-select
    // this.selectedItems = browseItems.filter(item => preSelectedItems.includes(item.id));
    this.selectedItems = this.getSelectedItemList();
    var dialogRef: any;
    dialogRef = this.dialog.open(ProductItemDialogComponent, {
      width: "30%",
      height: "60%",
      data: {
        items: browseItems,
        selectedItems: this.selectedItems,
        browseBy: browseBy,
      },
    });


    dialogRef.afterClosed().subscribe((result: any) => {
      if (result) {
        this.selectedItems = result.selectedItems; // Store selected items in the component property
        let selectedProducts = [];
        if (browseBy == "product") {
          selectedProducts = result.selectedItems;
        } else {
          let categoryIds = result.selectedItems.map(
            (category: any) => category.id
          );
          selectedProducts = this.productList.filter((product: any) =>
            categoryIds.includes(product.sub_class_id)
          );
        }
        const existingOffers = this.autoDiscountInfo.offer.offer || [];
        const newOffers = selectedProducts.map((product: any) => ({
          id: product.id,
          name: product.name,
          qty: 1,
          is_percentage: 1,
          variance: "",
        }));

        const mergedOffers = [...existingOffers];
        newOffers.forEach((item: any) => {
          const alreadyExists = mergedOffers.some((existing) => existing.id === item.id);
          if (!alreadyExists) {
            mergedOffers.push(item);
          }
        });
        this.autoDiscountInfo.offer.offer = mergedOffers;
        this.isFormDirty = true;
      }
    });
  }




  //dropdown saleitem
  getSaleItem(id: number): any {
    let item = this.productList.find((item: any) => item.id == id);
    return item;
  }
  isDisabled(): boolean {
    return true;
  }

  onVarianceInput(offer: any): void {
    if (offer.is_percentage && offer.variance !== null && offer.variance > 100) {
      offer.variance = 100;
    }

    if (this.varianceErrors && this.varianceErrors[offer.id]) {
      const variance = offer.variance;
      const isValid = !(variance === null || variance === undefined || variance === '' ||
        (offer.is_percentage && (variance < 0 || variance > 100)) ||
        (!offer.is_percentage && variance < 0));

      if (isValid) {
        this.varianceErrors[offer.id] = false;
      }
    }
  }

  isVarianceValid(offer: any): boolean {
    if (offer.variance === null || offer.variance === undefined || offer.variance === '') {
      return false;
    }

    if (offer.is_percentage) {
      return offer.variance > 0 && offer.variance <= 100;
    } else {
      return offer.variance > 0;
    }
  }



  /**
    * remove items from offer list
    */

  removeFromAutoDiscountInfo(id: number): void {
    if (id == 0) {
      this.autoDiscountInfo.offer.offer.length = 0;
    } else {
      if (this.autoDiscountInfo.offer !== undefined) {
        const index = this.autoDiscountInfo.offer.offer.findIndex(
          (i: any) => i.id == id
        );
        if (index !== -1) {
          this.autoDiscountInfo.offer.offer.splice(index, 1);
        }
      }
    }
    this.isFormDirty = true;
  }
}
